import ActiveClientsWrapper from "./ActiveClientsWrapper";

export default ActiveClientsWrapper;
